<ejs-dialog
    target=".dialogs" 
    class="simple-dialog" 
    [visible]='visible' 
    [animationSettings]='dialogService.getAnimationSettings()' 
    [resizeHandles]='dialogService.getResizeHandleDirection()' 
    [position]='dialogService.getPosition()' 
    [isModal]="true" 
    [allowDragging]="false" 
    [width]="'75vw'" 
    [height]="'75vh'" 
    [zIndex]="999" 
    [showCloseIcon]="true" 
    (close)="visibleChange.emit(false)"
  >
  <ng-template #header>
    <div class="d-flex align-items-center justify-content-center">
      <app-headline [title]="title()" [type]="'h5'" [class]="'text-primary'">
      </app-headline>
      <app-tooltip 
        [icon]="'help'" 
        [iconClass]="'fs-5 p-1'" 
        [text]="creatorMode() ? ('CALEVENTDETAILSCREATORHELP' | translate) : ('CALEVENTDETAILSPARTICIPANTHELP' | translate)" 
        [width]="'300px'" 
        [height]="'100px'" 
        [cssClass]="'helpTooltip p-2'" 
        [opensOn]="'Click'">
      </app-tooltip>
    </div>
  </ng-template>
  <ng-template #content>
    <div class="d-flex flex-column h-100 p-3 custom-scrollbar overflow-y-auto">
      <div class="details-layout h-100" [class.details-layout-single]="!hasParticipantsSidebar()">
        <div class="details-main min-w-0">
          <div class="custom-scrollbar overflow-y-auto h-100 pe-2 details-main-scroll">
            <div class="d-flex flex-column gap-3">
              <!-- description and attachments -->
              <section class="border rounded-3 p-3">
                <div class="text-muted fs-normal fw-bold mb-1">{{ 'CALDETAILCREATOR' | translate }}</div>
                <div class="d-flex flex-column gap-2 mb-2">
                  @if (creator(); as creatorUser) {
                    <app-avatar
                      [image]="getCreatorAvatar()"
                      [name]="getCreatorName()"
                      [subTitle]="''"
                      [profileUserId]="creatorUser.id"
                      [openProfileOnClick]="true"
                      [type]="'default'"
                      >
                    </app-avatar>
                  } @else {
                    <div>{{ event().creator.user_id ?? '-' }}</div>
                  }
                </div>
                <div class="text-muted fs-normal fw-bold mb-1">{{ 'CALDETAILDESCRIPTION' | translate }}</div>
                @if (description()) {
                  <app-content
                    [type]="'richtext'"
                    [expandable]="false"
                    [innerHTML]="description() | linkify"
                    [class]="'text-muted fs-small mb-2 d-block'">
                  </app-content>
                } @else {
                  <div class="text-muted fs-small mb-2">{{ 'CALDETAILNODESCRIPTION' | translate }}</div>
                }
                <div class="text-muted fs-normal fw-bold mb-1">{{ 'CALDETAILATTACHMENTS' | translate }}</div>
                  @if (event().files.length) {
                    <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
                    @for (file of event().files; track file.uuid) {
                      <app-item-documents-preview-available
                        [file]="file"
                        [files]="event().files"
                        [selectable]="false">
                      </app-item-documents-preview-available>
                    }
                  </div>
                } @else {
                  <div class="text-muted fs-small">{{'CALDETAILNOATTACHMENTS' | translate }}</div>
                }
              </section>
              <!-- schedule and timing -->
              <section class="border rounded-3 p-3">
                <div class="text-muted fs-normal fw-bold mb-2">{{ 'CALDETAILSCHEDULE' | translate }}</div>
                <div class="d-flex flex-column gap-2">
                  <div class="d-flex flex-row flex-wrap align-content-center justify-content-between">
                    <div class="text-muted fs-small">{{ 'CALDETAILSTART' | translate }}</div>
                    <div class="text-muted fs-small">{{ event().timing.start_at | date : 'medium' }}</div>
                  </div>
                  <div class="d-flex flex-row flex-wrap align-content-center justify-content-between">
                    <div class="text-muted fs-small">{{ 'CALDETAILEND' | translate }}</div>
                    <div class="text-muted fs-small">{{ endTime() | date : 'medium' }}</div>
                  </div>
                  <div class="d-flex flex-row flex-wrap align-content-center justify-content-between">
                    <div class="text-muted fs-small">{{ 'CALDETAILDURATION' | translate }}</div>
                    <div class="text-muted fs-small">{{ formatDuration(event().timing.duration) }}</div>
                  </div>
                  <div class="d-flex flex-row flex-wrap align-content-center justify-content-between">
                    <div class="text-muted fs-small">{{ 'CALDETAILTIMEZONE' | translate }}</div>
                    <div class="text-muted fs-small">{{ event().timing.timezone }}</div>
                  </div>
                  @if (event().timing.notify_before !== null) {
                    <div class="d-flex flex-row flex-wrap align-content-center justify-content-between">
                      <div class="text-muted fs-small">{{ 'CALDETAILREMINDER' | translate }}</div>
                      <div class="text-muted fs-small">{{ event().timing.notify_before }} {{ 'CALDETAILREMINDERLABEL' | translate }}</div>
                    </div>
                  }
                  @if (event().timing.notify_time !== null) {
                    <div class="d-flex flex-row flex-wrap align-content-center justify-content-between">
                      <div class="text-muted fs-small">{{ 'CALDETAILREMINDERTIME' | translate }}</div>
                      <div class="text-muted fs-small">{{ event().timing.notify_time }}</div>
                    </div>
                  }
                </div>
              </section>
              <!-- location and priority -->
              <section class="border rounded-3 p-3">
                <div class="text-muted fs-normal fw-bold mb-2">{{ 'CALDETAILDETAILS' | translate }}</div>
                <div class="d-flex flex-column gap-2">
                  @if(event().location !== null && event().location !== ''){
                    <div class="d-flex flex-row flex-wrap align-content-center justify-content-between">
                      <div class="text-muted fs-small">{{ 'CALDETAILLOCATION' | translate }}</div>
                      <div class="text-muted fs-small">{{ location() }}</div>
                    </div>
                  }
                  <div class="d-flex flex-row flex-wrap align-content-center justify-content-between">
                    <div class="text-muted fs-small">{{ 'CALDETAILPRIOTIRY' | translate }}</div>
                    <div
                      class="fs-small"
                      [class.text-muted]="!event().priority"
                      [class.text-danger]="event().priority === 'high'"
                      [class.text-warning]="event().priority === 'medium'"
                      [class.text-success]="event().priority === 'low'">
                      {{ (event().priority || '-') | titlecase }}
                    </div>
                  </div>
                  @if(event().capacity !== null) {
                    <div class="d-flex flex-row flex-wrap align-content-center justify-content-between">
                      <div class="text-muted fs-small">{{ 'CALDETAILEVENTCAPACITY' | translate }}</div>
                      <div class="text-muted fs-small">{{ event().capacity }}</div>
                    </div>
                  }
                  @if(event().inventories.length) {
                    <div class="text-muted fs-small">{{ 'CALDETAILRESOURCES' | translate }}</div>
                    <ul class="fs-small mb-0">
                      @for(item of event().inventories; track $index) {
                        <li>
                          {{ item.inventory.name }}@if ((item.quantity ?? 1) > 1) { ({{ item.quantity }}) }
                        </li>
                      }
                    </ul>
                  }
                </div>
              </section>
              <!-- participants -->
              @if(
                creatorMode() &&
                (
                  event().participants.user_ids.length || 
                  event().participants.group_ids.length || 
                  event().participants.external_user_emails.length ||
                  event().participants.all_users
                )
              ) {
                <section class="border rounded-3 p-3">
                  <div class="text-muted fs-normal fw-bold mb-2">{{ 'CALDETAILPARTICIPANTS' | translate }}</div>
                  <div class="d-flex flex-column gap-2">
                  @if (event().participants.all_users) {
                    <div class="text-muted fs-small">{{ 'CALDETAILALLUSERSINVITED' | translate }}</div>
                  }
                  @if (event().participants.user_ids.length) {
                    <div>
                      <div class="text-muted fs-small">{{ 'CALDETAILUSERS' | translate }}</div>
                        <div class="d-flex flex-wrap gap-2 mt-1">
                          @for (userId of event().participants.user_ids; track userId) {
                            <div class="d-inline-flex align-items-center border rounded-pill ps-1 pe-2 py-1 gap-2">
                              <app-avatar
                                [image]="participantUserAvatar(userId)"
                                [name]="participantUserName(userId)"
                                [type]="'xxs'"
                                [icon]="'person'"
                                [border]="false"
                                [profileUserId]="participantUser(userId)?.id ?? null"
                                [openProfileOnClick]="true"
                              >
                              </app-avatar>
                              <span class="text-muted fs-small lh-1">{{ participantUserName(userId) }}</span>
                            </div>
                          }
                      </div>
                    </div>
                  }
                  @if (event().participants.group_ids.length) {
                    <div>
                      <div class="text-muted fs-small">{{ 'CALDETAILGROUPS' | translate }}</div>
                        <div class="d-flex flex-wrap gap-2 mt-1">
                          @for (groupId of event().participants.group_ids; track groupId) {
                            <div class="d-inline-flex align-items-center border rounded-pill ps-1 pe-2 py-1 gap-2">
                              <app-avatar
                                [image]="participantGroupAvatar(groupId)"
                                [name]="participantGroupName(groupId)"
                                [type]="'xxs'"
                                [icon]="'group'"
                                [border]="false"
                              >
                              </app-avatar>
                              <span class="text-muted fs-small lh-1">{{ participantGroupName(groupId) }}</span>
                            </div>
                          }
                        </div>
                      </div>
                  }
                  @if (event().participants.external_user_emails.length) {
                      <div>
                        <div class="text-muted fs-verysmall">{{ 'CALDETAILEXTERNALUSERS' | translate }}</div>
                        <div class="d-flex flex-column gap-1 mt-1">
                          @for (email of event().participants.external_user_emails; track email) {
                            <span>{{ email }}</span>
                          }
                        </div>
                      </div>
                  }
                  </div>
                </section>
              }
            </div>
          </div>
        </div>
        @if (hasParticipantsSidebar()) {
          <div class="details-sidebar min-w-0">
            <div class="border rounded-3 p-3 h-100 d-flex flex-column details-sidebar-card">
              @if (eventAllowsRSVP()) {
                <section class="border rounded-3 p-3 mb-3">
                  <div class="text-muted fs-verysmall mb-2">{{ 'CALDETAILPERSONALRSVP' | translate }}</div>
                  <div class="d-flex flex-wrap gap-1" [aria-label]="'CALDETAILPERSONALRSVP' | translate">
                    @for (answer of rsvpOptions; track answer) {
                      <app-form-button
                        [cssClass]="rsvpButtonClass(answer, this.personalRsvp()) + ' compact-button'"
                        [disabled]="isRsvpDisabled(answer)"
                        (click)="setPersonalRsvp(answer)"
                        [text]="rsvpLabel(answer)"
                      >
                      </app-form-button>
                    }
                  </div>
                </section>
              }
              <div class="text-muted fs-normal fw-bold mb-3">{{ 'CALDETAILPARTICIPANTS' | translate }}</div>
              <div class="custom-scrollbar overflow-y-auto flex-grow-1 details-sidebar-scroll">
                <div class="d-flex flex-column gap-2">
                  @for (participant of participantsList(); track participant.user.id) {
                    <div class="border rounded-3 p-2 d-flex align-items-center justify-content-between gap-2">
                      <div class="d-flex align-items-center gap-2 min-w-0 flex-grow-1">
                        <app-avatar
                          [image]="participant.user.avatar?.path ?? ''"
                        [name]="participantEntryName(participant)"
                        [subTitle]="''"
                        [profileUserId]="participant.user.id"
                        [openProfileOnClick]="true"
                        [type]="'small'"
                      >
                      </app-avatar>
                      <div class="d-flex flex-column align-items-start gap-2 min-w-0 flex-grow-1">
                        <span class="text-break text-primary">{{ participantEntryName(participant) }}</span>
                        @if (creatorMode() && calendarAllowsRSVP()) {
                          @if (participant.answer === null) {
                            <span class="text-primary fs-verysmall">
                              {{ 'CALDETAILRVSPPENDING' | translate }}
                            </span>
                          } @else {
                            <button
                              type="button"
                              tabindex="-1"
                              aria-disabled="true"
                              [class]="'participant-rsvp-status e-btn e-control e-lib compact-button ' + rsvpButtonClass(participant.answer, participant.answer)"
                            >
                              {{ rsvpLabel(participant.answer) }}
                            </button>
                          }
                        }
                      </div>
                    </div>
                    @if (creatorMode() && canResetParticipantAnswer(participant)) {
                      <app-tooltip [text]="('CALRESETUSERANSWER' | translate)" [opensOn]="'Auto'">
                        <app-form-button
                          (click)="resetParticipantAnswer(participant.user.id)"
                          [aria-label]="'CALRESETUSERANSWER' | translate"
                          [icon]="'restart_alt'"
                          [cssClass]="'e-outline'"
                        ></app-form-button>
                      </app-tooltip>
                    }
                  </div>
                }

                @for (email of event().participants.external_user_emails; track email) {
                  <div class="border rounded-3 p-2 d-flex align-items-center justify-content-between gap-2">
                    <span class="text-break">{{ email }}</span>
                    @if (creatorMode()) {
                      <span class="badge rounded-pill bg-primary text-white fw-normal">{{"CALDETAILEXTERNALUSERS" | translate}}</span>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
          </div>
        }
      </div>
    </div>
  </ng-template>
</ejs-dialog>
